import sha256 from 'crypto-js/sha256';

function Test() {
    return <div>{sha256("123465").toString()}</div>
}

export default Test;